import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { IAction } from '~/src/store';

import { ESpeedBonusActions } from './constants';

export type TActionResultEntity = 'activation' | 'request' | 'none'
export type TActionResultStatus = EResultPopupStatus.SUCCESS | EResultPopupStatus.ERROR | 'none'
export type TActionResultTarget = 'popup' | 'alert'

export type TActionResult = {
    entity: TActionResultEntity,
    status: TActionResultStatus,
    header: string,
    message?: string,
    target?: TActionResultTarget,
}

export const setResult = (result: TActionResult): IAction<ESpeedBonusActions.setResult, TActionResult> => ({
    type: ESpeedBonusActions.setResult,
    payload: result,
});
